/* eslint-disable */

<template>
    <BaseDialog
        :eager="true"
        :max_width="`80%`"
        :dialog="dialog"
        v-on:close_dialog="closeDialog">
        <template v-slot:title>
            <span v-if="!!location_id">{{loc.name}} - MODIFICA</span>
            <span v-else>NUOVA SEDE</span>
        </template>
        <LocationForm
            class="mx-2"
            ref="locationForm"
            :enable_registered="enable_registered"
            v-bind:add_contact_enable="true"
            v-on:validationChanged="validationChanged"
            v-on:add_contact="addContact"
            />
        <template v-slot:action>
            <div class="d-flex align-center justify-center my-4">
                <v-btn color="primary" :disabled="!valid" @click="saveLocation">Salva</v-btn>
                <v-btn text class="ml-2" @click="closeDialog()">annulla</v-btn>
            </div>
        </template>
    </BaseDialog>
</template>

<script>
import {getModel} from '../../utils/model'
import LocationForm from './LocationForm'
import BaseDialog from '../../components/dialogs/BaseDialog'
export default {
    props: {
        client_id: {
            type: String,
            required: true
        },
        enable_registered: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    components: { LocationForm, BaseDialog},
    data(){
        return {
            loc: {},
            valid: true,
            location_id: null,
            dialog: false,
            client: {},
            contacts: []
        }
    },
    beforeDestroy() {
        // console.log("BEFORE LOCATION EDIT", this.$refs.locationForm)
        this.loc = null
        this.client= null
        this.contacts = null
        // console.log("AFTER LOCATION EDIT", this.$refs.locationForm)
    },
    methods: {
        resetValidation(){
            // console.log("****", this.$refs.locationForm)
            this.$refs.locationForm.resetValidation()
        },
        async saveLocation(){
            try {
                this.loc = this.$refs.locationForm.getLocationData()
                this.loc.country = this.loc.country.toUpperCase()
                if(this.loc.name == null || this.loc.name == ''){
                    this.loc.name = this.loc.address + " " + this.loc.addrNum + " " + this.loc.city - "("+ location.district+")"
                }
                this.loc.updated_by = this.$store.state.user._id
                this.loc.updated = (new Date()).getTime()
                this.loc.complete = true
                let docs_to_save = [this.loc]
                if (this.loc.is_registered){
                    let client = await this.$store.state.$pouch.get('registry', this.loc.client_id)
                    if(client){
                        client.registered_office = this.loc._id
                        docs_to_save.push(client)
                    }
                }
                let res = await this.$store.state.$pouch.bulkDocs('registry', docs_to_save)
                this.closeDialog(true)
                this.$store.commit("showSnackbar", {text: "Sede salvata con successo", color: 'primary'})
            } catch(error) {
                console.log('error', error)
            }
            /*let res = await this.$store.state.$pouch.put('registry', this.loc)
            // console.log("DEBUG, aggiunta nuova sede", res);
            if(res.ok){
                if (this.loc.is_registered){
                    let client = await this.$store.state.$pouch.get('registry', this.loc.client_id)
                    if(client){
                        client.registered_office = this.loc._id
                        let res2 = await this.$store.state.$pouch.put('registry', client)
                        if(res2.ok){
                            console.log("cliente aggiornato con successo")
                        }
                    }
                }
                this.closeDialog(true)
                this.$store.commit("showSnackbar", {text: "Sede salvata con successo", color: 'primary'})
            }*/ 
        },
        closeDialog(saved){
            if (saved) {
               this.$emit('locationDialogClosed', this.loc)
            }
            this.dialog = false;
            this.loc = {};
        },
        async openDialog(client_id, location_id){
            this.client_id = client_id
            this.location_id = location_id
            await this.getContacts()
            if (location_id) {
                console.log("location", location_id)
                this.loc = await this.$store.state.$pouch.get('registry', location_id)
                // console.log("location obj", this.loc)
            } else {
                
                let Location = getModel("Location");
                this.loc = Location({
                    created_by: this.$store.state.user._id,
                    client_id: this.client_id,
                    country: 'ITALIA',
                    registered_office: false
                })

                // console.log("NEW location obj", this.loc)
            }
            this.$refs.locationForm.initData(this.loc, this.contacts)
            this.dialog = true;
            
            this.resetValidation()
            
        },
        async getContacts(){
            let client = await this.$store.state.$pouch.get('registry', this.client_id)
            this.contacts = Object.values(client.contacts)
            this.$refs.locationForm.updateContacts(this.contacts)
        },
        validationChanged(valid){
            //console.log('valid value', valid)
            this.valid = valid
        },
        addContact(){
            console.log('ADD CONTACT')
            this.$emit('add_contact')
        }
    }
}
</script>

<style>

</style>
